import React from 'react'
import moment from 'moment'
import debounce from 'debounce'

import { API_ENDPOINT } from '../../index'

import {
    _postSetProductOrderStatusPaid,
    _getSearchEnterprise,
    _postCreateCreditPayment,
    _postSearchCreditPayments,
    _postCreditPaymentSent,
    _postCreditPaymentDelete,
} from '../../services'

import EnterpriseTable from './enterprise-table'
import NotifiedUsersTable from './notified-users-table'

import {
    Card,
    Row,
    Col,
    Icon,
    Menu,
    Input,
    Tag,
    Divider,
    Table,
    Checkbox,
    Upload,
    Tabs,
    message,
    Dropdown,
    DatePicker,
    Button,
    Modal,
    Popconfirm
} from 'antd'

const { confirm } = Modal

const { RangePicker } = DatePicker

class CreditPayment extends React.Component{

    state = {
        loading: true,
        payments: [],
        modalVisible: false,
        renderModal: false,
        openOnly: true,
        overdueOnly: false,
        
        notifiedUsers: [],
        userModalVisible: false,
        
        page: 1, 
        searchTerm: '',
        limit: 10,
        count: 0,
        enterprises: [],
        activeEnterprise: false,
        fromDate: false,
        toDate: false,

        dateSentModal: false,
        dateSent: false,
    }

    render(){

        const { modalVisible, renderModal, activeEnterprise, fromDate, toDate, userModalVisible, notifiedUsers, dateSentModal } = this.state
    
        return(
            <div style={{margin: 16}}>
                {renderModal && 
                    <Modal
                        centered
                        onCancel={this.handleCloseModal}
                        afterClose={this.handleAfterCloseModal}
                        visible={modalVisible}
                    >
                        <EnterpriseTable
                            handleSelect={this.handleSelectEnterprise}
                        />
                    </Modal>
                }
                {this.renderDateSentModal()}
                <Modal
                    centered
                    footer={null}
                    onCancel={this.handleCloseUserModal}
                    visible={userModalVisible}
                >  
                    <NotifiedUsersTable
                        paymentId={this.state.activePaymentId}
                        users={notifiedUsers}
                    />
                </Modal>
                <Card
                    title={
                        <Row type="flex" justify="space-between">
                            <Col>
                                Credit Payment
                            </Col>
                            <Col>
                                {this.renderGenerateButton()}
                            </Col>
                        </Row>
                    }
                >   
                    {
                        activeEnterprise && 
                        <Card style={{marginBottom: 24}}>
                            <div>{activeEnterprise.companyName} <a
                                style={{marginLeft: 16}}
                                onClick={this.handleClearActiveEnterprise}
                            >Clear</a></div>
                            <div>
                                Select End Date:
                                <DatePicker
                                    value={ toDate }
                                    onChange={this.handleDateChange}
                                    style={{marginLeft: 16}}
                                />
                            </div>
                            <div>
                                <Button
                                    onClick={this.handleConfirmCreatePayment}
                                    style={{marginTop: 16}}
                                    type="primary"
                                    disabled={ !toDate}
                                >Generate</Button>
                            </div>
                        </Card>
                    }
                    <Input
                        style={{width: 400, marginBottom: 24}}
                        placeholder="Search Ref Number"
                        onChange={this.handleSearch}
                    />
                    <Checkbox
                        style={{marginLeft: 16}}
                        defaultChecked={this.state.openOnly}
                        onChange={this.handleOpenOnlyToggle}
                    >Open Payments Only</Checkbox>

                    <Checkbox
                        style={{marginLeft: 16}}
                        defaultChecked={this.state.overdueOnly}
                        onChange={this.handleOverdueOnlyToggle}
                    >Overdue Only</Checkbox>
                    {this.renderTable()}
                </Card>
            </div>
        )
    }

    constructor(props){
        super(props)

        this.getPayments()

        this.setSearch = debounce(this.setSearch, 400)
    }

    getPayments = () => {

        const { searchTerm, page, limit, openOnly, overdueOnly } = this.state

        this.setState({loading: true})

        _postSearchCreditPayments({
            searchTerm,
            page,
            limit,
            openOnly,
            overdueOnly
        })
        .then( res => {
            const { payments, count } = res.data

            this.setState({
                loading: false,
                payments,
                count
            })
        })
        
    }

    setSearch = (searchTerm) => {
        this.setState({
            searchTerm,
            page: 1
        }, this.getPayments)
    }

    handleOpenOnlyToggle = () => {
        this.setState({
            openOnly: !this.state.openOnly
        }, this.getPayments)
    }

    handleOverdueOnlyToggle = () => {
        this.setState({
            overdueOnly: !this.state.overdueOnly
        }, this.getPayments)
    }

    handleSearch = (e) => {
        this.setSearch(e.target.value)
    }

    handleConfirmCreatePayment = () => {

        const { activeEnterprise, toDate } = this.state

        confirm({
            title: 'Confirm create payment?',
            content: `Clicking confirm will send ${activeEnterprise.companyName} an invoice requesting for all unpaid product orders till ${moment(toDate).format('LL')} to be paid.`,
            centered: true,
            onOk: this.handleCreatePayment
        })
        
    }

    handleCreatePayment = () => {
        
        const { activeEnterprise, toDate } = this.state

        message.loading('Please be patient')

        _postCreateCreditPayment({
            // fromDate,
            toDate,
            enterpriseId: activeEnterprise._id
        })
        .then( res => {

            message.destroy()

            const { payment } = res.data

            if( payment ){
                this.setState({
                    payments: [payment, ...this.state.payments],
                    activeEnterprise: false
                })
                
                if( payment.notifiedUsers.length == 0 ){
                    message.error('No finance office in this enterprise')
                }
    
                payment.notifiedUsers.map( _user => {
                    message.success( `Sent request to ${_user.email}`)
                })

                window.open(`/credit-payment/${payment._id}`,'_blank')

            } else {
                message.error( res.data.message )
            }

        })

    }
 
    handleDateChange = (toDate) => {
        this.setState({
            toDate
        })
    }

    handleClearActiveEnterprise = () => {
        this.setState({
            activeEnterprise: false
        })
    }

    handleOpenModal = () => {

        this.setState({
            renderModal: true,
            modalVisible: true
        })

    }

    handleCloseModal = () => {
        this.setState({
            modalVisible: false
        })
    }

    handleAfterCloseModal = () => {
        this.setState({
            renderModal: false,
            // activeEnterprise: false
        })
    }

    handleSelectEnterprise = (enterprise) => {

        this.setState({
            activeEnterprise:enterprise
        }, this.handleCloseModal )
        
    }

    renderTable = () => {

        const { payments, page, limit, count, loading } = this.state

        const columns = [ {
            title: 'Ref No.',
            dataIndex: 'refNumber'
        },{
            title: 'Date Created',
            dataIndex: 'dateCreated',
            render:(dateCreated)=>moment(dateCreated).format('LL')
        },{
            title: 'Payments Up To',
            render: (payment) => <div>{moment(payment.toDate).format('LL')}</div>
        },{
            title: 'Enterprise',
            dataIndex: 'enterpriseName'
        },{
            title: 'Notify',
            dataIndex: 'notifiedUsers',
            render:(notifiedUsers, record) => <a onClick={()=>this.handleOpenUserModal(notifiedUsers, record._id)}>{notifiedUsers.length} emails <Divider type="vertical"/> {notifiedUsers.filter( _nu => _nu.doNotSend ).length} DNS </a>
        },{
            title: 'Date Sent',
            dataIndex: 'dateSent',
            render: (dateDue) => dateDue ? moment(dateDue).format('LL') : '-'
        },{
            title: 'Date Due',
            dataIndex: 'dateDue',
            render: (dateDue) => {

                const days = moment().diff(moment(dateDue), 'days')

                if( days > 0 ){
                    return <div>
                                <div
                                    style={{
                                        color: days >= 25?"red":'rgba(0,0,0,0.65)'
                                    }}
                                >{days} day(s) overdue</div>
                                {days >= 25 && <span>Please take action</span>}
                            </div>
                }

                return moment(dateDue).format('LL')
            }
        },{
            title: 'Status',
            dataIndex: 'closed',
            render: (closed, record) => this.renderStatus(record)
        },{
            title: "Actions",
            render: (payment) => (

                <span>
                    <a onClick={()=>window.open(`/credit-payment/${payment._id}`)}>View</a>
                    <Divider type="vertical"/>
                    <a onClick={()=>window.open(`${API_ENDPOINT}/api/admin/enterprise/payment-pack/${payment._id}`, '_self')}>Download</a>
                    { !(payment.sent || payment.closed) &&
                        <React.Fragment>
                            <Divider type="vertical" />
                            {/* <Popconfirm
                                title="Confirm Send?"
                                onConfirm={() => this.handleSentClicked(payment._id)}
                                okText="Yes"
                                cancelText="No"
                                >
                                <a>Send</a>
                            </Popconfirm> */}
                            <a onClick={() => this.handleSentClicked(payment._id)}>Send</a>
                        </React.Fragment>
                    }
                    { !(payment.closed) &&
                        <React.Fragment>
                            <Divider type="vertical" />
                            <Popconfirm
                                title="Confirm Delete?"
                                onConfirm={() => this.handleDeleteClicked(payment._id)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <a style={{color: 'red'}}>Delete</a>
                            </Popconfirm>
                        </React.Fragment>
                    }
                </span>

                )
        }]

        return(
            <Table
                loading={loading}
                pagination={{
                    current: page,
                    pageSize: limit,
                    total: count,
                    onChange: (nextPage)=>this.setState({ page: nextPage }, this.getPayments)
                }}
                columns={columns}
                dataSource={payments}
            />
        )

    }

    renderStatus = (record) => {

        if (record.closed) {
            return <Tag color="#f5222d">Closed</Tag>
        } 

        if (record.sent) {
            return <Tag color="#fa8c16">Sent</Tag>
        }

        return <Tag color="#1890ff">Open</Tag>
    }

    renderDateSentModal = () => {

        const {dateSentModal, dateSent, paymentId} = this.state;

        return (
            <Modal
                centered
                onCancel={() => this.setState({ dateSentModal: false })}
                onOk={() => this.handleSentConfirm({paymentId, dateSent})}
                visible={dateSentModal}
            >
                <div>
                    Date Sent:
                    <DatePicker
                        value={dateSent}
                        onChange={(dateSent) => this.setState({ dateSent })}
                        style={{ marginLeft: 16 }}
                    />
                </div>
            </Modal>
        )
    }

    handleOpenUserModal = (notifiedUsers, paymentId) => {
        this.setState({
            activePaymentId: paymentId,
            notifiedUsers,
            userModalVisible: true
        })
    }

    handleCloseUserModal = () => {
        this.setState({
            activePaymentId: false,
            notifiedUsers: [],
            userModalVisible: false
        }, this.getPayments)
    }

    renderGenerateButton = () => {

        const { data } = this.state

        return(
            <Button
                onClick={this.handleOpenModal}
                type="primary"
            >
                Create Payment
            </Button>
        )

    }

    handleSentClicked = (paymentId) => {

        this.setState({
            dateSentModal: true,
            paymentId,
        })
    }

    handleSentConfirm = ({paymentId, dateSent}) => {

        if (dateSent) {
            _postCreditPaymentSent({paymentId, dateSent})
            .then(_creditPayment => {
                this.setState({ 
                    dateSentModal: false,
                    dateSent: false
                })
                this.getPayments()
            })
            .catch(err => console.log({err}))
        }
    }

    handleDeleteClicked = (paymentId) => {
        _postCreditPaymentDelete({paymentId})
        .then(_creditPayment => this.getPayments())
        .catch(err => console.log({err}))
    }


}

export default CreditPayment


// WEBPACK FOOTER //
// ./src/components/credit-payment/index.js